import { UserRequiredFieldsProfile, FormConfig } from '@/features/auth/types/User.types';

const DEFAULT_FORM_CONFIG: FormConfig = { visible: false, required: false, editable: false };

// Single source of truth for the profile fields. The one place to edit when a
// profile field is added.
export const PROFILE_FIELDS: readonly (keyof UserRequiredFieldsProfile)[] = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'birthdate',
  'street',
  'houseNumber',
  'addressAddition',
  'city',
  'postcode',
  'country',
];

// Returns a complete profile: every known field is present, with any field the
// backend omitted (e.g. a tenant setting that predates newer fields) defaulting
// to hidden & optional. This prevents `profile[field]` from ever being undefined
// downstream.
export const resolveProfile = (
  profile?: Partial<UserRequiredFieldsProfile>,
): UserRequiredFieldsProfile =>
  Object.fromEntries(
    PROFILE_FIELDS.map((field) => [field, profile?.[field] ?? { ...DEFAULT_FORM_CONFIG }]),
  ) as unknown as UserRequiredFieldsProfile;
